export const RequiredDateStatusTagStatusColors = {
	MISSING: 'warning',
	UPCOMING: 'warning',
	PASSED: 'danger',
	APPLIED: 'info',
	LOCKED: 'grey-dark'
};

export enum RequiredDateStatusTagEnum {
	MISSING = 'MISSING',
	UPCOMING = 'UPCOMING',
	PASSED = 'PASSED',
	APPLIED = 'APPLIED',
	LOCKED = 'LOCKED'
}

export const RequiredDateStatusTagLines = {
	MISSING: 'Missing Required Date',
	UPCOMING: 'Required Date Upcoming',
	PASSED: 'Required Date Passed',
	APPLIED: '',
	LOCKED: 'Required'
};

export const C_COMMENT_MAX_LENGTH = 26;
